// src/app/state/authSession.js

const AUTH_EVENT = "auth:changed";

function emitAuthChanged() {
  try {
    window.dispatchEvent(new Event(AUTH_EVENT));
  } catch {
    // no-op
  }
}

export function getSession() {
  try {
    const sessionStr = localStorage.getItem("session");
    if (!sessionStr) return null;
    return JSON.parse(sessionStr);
  } catch (error) {
    console.error("Error getting session:", error);
    return null;
  }
}

export function getAccessToken() {
  try {
    const session = getSession();
    if (session?.accessToken) return session.accessToken;

    const token = localStorage.getItem("accessToken");
    return token || null;
  } catch (error) {
    console.error("Error getting access token:", error);
    return null;
  }
}

export function getUser() {
  try {
    const session = getSession();
    if (session?.user) {
      console.log('🔍 getUser from session:', session.user);
      return session.user;
    }

    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      console.log('🔍 getUser from localStorage:', user);
      return user;
    }
    
    return null;
  } catch (error) {
    console.error("Error getting user:", error);
    return null;
  }
}

export function setSession(data) {
  try {
    let user = data?.user ?? null;
    
    console.log('🔍 setSession called with user:', user);
    
    // ✅ Force admin role for admin email
    if (user && user.email === "admin@worldcoinscom.com" && user.role !== "ADMIN") {
      console.log('🔧 Forcing ADMIN role in setSession');
      user.role = "ADMIN";
    }
    
    // ✅ Ensure user is not null
    if (!user) {
      console.warn('⚠️ User is null in setSession');
      // Try to get user from localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        user = JSON.parse(storedUser);
        console.log('📦 Restored user from localStorage:', user);
      }
    }

    const sessionData = {
      accessToken: data?.accessToken || null,
      user: user,
    };

    console.log('💾 Storing session:', sessionData);

    localStorage.setItem("session", JSON.stringify(sessionData));

    // compatibility keys
    if (sessionData.accessToken) {
      localStorage.setItem("accessToken", sessionData.accessToken);
    } else {
      localStorage.removeItem("accessToken");
    }

    if (sessionData.user) {
      localStorage.setItem("user", JSON.stringify(sessionData.user));
      console.log('✅ User stored with role:', sessionData.user.role);
    } else {
      localStorage.removeItem("user");
      console.log('⚠️ No user to store');
    }

    emitAuthChanged();
    return true;
  } catch (error) {
    console.error("Error setting session:", error);
    return false;
  }
}

export function clearSession() {
  try {
    localStorage.removeItem("session");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    emitAuthChanged();
    console.log('✅ Session cleared');
    return true;
  } catch (error) {
    console.error("Error clearing session:", error);
    return false;
  }
}

export function isAuthenticated() {
  return !!getAccessToken();
}

export function hasRole(role) {
  const user = getUser();
  if (!user) return false;

  if (Array.isArray(role)) {
    return role.includes(user.role);
  }

  return user.role === role;
}

export function getKycStatus() {
  return "VERIFIED";
}

export function isKycVerified() {
  return true;
}
